import styles from './scenes.module.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/src/ScrollTrigger';
import { useEffect, useRef, useState } from 'react';
import DOMPurify from 'dompurify';
gsap.registerPlugin(ScrollTrigger);
let colors = ['#FAF0F0', '#FAF5F0', '#F0F5FA'];
let scenesImages = ['bag', 'backpack', 'luggage'];
const Scenes = ({ textData }) => {
  const ctnRef = useRef(null);
  const scenesTextBoxRef = useRef(null);
  let scenes = 3;
  useEffect(() => {
    ctnRef.current.style.setProperty('--items', scenes);
  });
  useEffect(() => {
    let heightArray = [];
    scenesTextBoxRef.current
      .querySelectorAll('div')
      .forEach((item) => heightArray.push(item.offsetHeight));
    scenesTextBoxRef.current.style.setProperty(
      '--height',
      `${Math.max(...heightArray)}px`,
    );
  });
  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        pin: true,
        scrub: 1,
        start: 'top top',
        end: '260%',
        onUpdate: (e) => {
          let currentIndex = Math.trunc(
            Math.min(e.progress, (scenes - 1) / scenes) / (1 / scenes),
          );

          ctnRef.current.style.background = colors[currentIndex];

          if (e.progress === 1) {
            ctnRef.current.style.setProperty('--current-index', scenes - 1);
          } else {
            ctnRef.current.style.setProperty(
              '--current-index',
              `${currentIndex}`,
            );
          }
        },
      },
    });

    document
      .querySelectorAll(`.${styles.imgBox} > *`)
      .forEach((item, index, array) => {
        if (index < array.length - 1) {
          tl.to(item, {
            '--an-clip-progress': '-276%',
            duration: 4,
          });
        }
      });

    tl.to(scenesTextBoxRef.current.querySelectorAll('div')[0], {
      '--an-clip-progress': '-276%',
      duration: 4,
    });
  }, []);

  const scenesIcons = [
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70825 33.6982L11.1312 25.8237C11.6476 24.1453 13.1983 23 14.9543 23H33.0457C34.8017 23 36.3524 24.1453 36.8688 25.8237L39.2917 33.6982C39.7275 35.1143 39.3447 36.6553 38.2971 37.7029L37.1716 38.8284C36.4214 39.5786 35.404 40 34.3431 40H13.6569C12.596 40 11.5786 39.5786 10.8284 38.8284L9.70294 37.7029C8.65527 36.6553 8.27253 35.1143 8.70825 33.6982Z"
        stroke="#CC6666"
        stroke-width="4"
      />
      <path
        d="M17 28C15.8954 28 15 28.8954 15 30C15 31.1046 15.8954 32 17 32V28ZM31 32C32.1046 32 33 31.1046 33 30C33 28.8954 32.1046 28 31 28V32ZM17 32H31V28H17V32Z"
        fill="#CC6666"
      />
      <path
        d="M18 23.9987C18 3 30 2.99893 30 24.0016"
        stroke="#CC6666"
        stroke-width="4"
      />
    </svg>,
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 10.5H20C14.4772 10.5 10 14.9772 10 20.5V38.5C10 40.7091 11.7909 42.5 14 42.5H34C36.2091 42.5 38 40.7091 38 38.5V20.5C38 14.9772 33.5228 10.5 28 10.5Z"
        stroke="#CC9F66"
        stroke-width="4"
      />
      <path
        d="M11 28.5C9.89543 28.5 9 29.3954 9 30.5C9 31.6046 9.89543 32.5 11 32.5V28.5ZM37 32.5C38.1046 32.5 39 31.6046 39 30.5C39 29.3954 38.1046 28.5 37 28.5V32.5ZM11 32.5H37V28.5H11V32.5Z"
        fill="#CC9F66"
      />
      <circle cx="24" cy="19.5" r="3" fill="#CC9F66" />
      <path
        d="M12 7.5C12 5.84315 13.3431 4.5 15 4.5C16.6569 4.5 18 5.84315 18 7.5V12.5C18 14.1569 16.6569 15.5 15 15.5H12V7.5Z"
        fill="#CC9F66"
      />
      <path
        d="M30 7.5C30 5.84315 31.3431 4.5 33 4.5C34.6569 4.5 36 5.84315 36 7.5V15.5C32.6863 15.5 30 12.8137 30 9.5V7.5Z"
        fill="#CC9F66"
      />
    </svg>,
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34 12.5H14C11.7909 12.5 10 14.2909 10 16.5V36.5C10 38.7091 11.7909 40.5 14 40.5H34C36.2091 40.5 38 38.7091 38 36.5V16.5C38 14.2909 36.2091 12.5 34 12.5Z"
        stroke="#669CCC"
        stroke-width="4"
      />
      <path
        d="M31 12.5V14.5H33V12.5H31ZM17 12.5H15V14.5H17V12.5ZM21 8.5H27V4.5H21V8.5ZM29 10.5V12.5H33V10.5H29ZM31 10.5H17V14.5H31V10.5ZM19 12.5V10.5H15V12.5H19ZM27 8.5C28.1046 8.5 29 9.39543 29 10.5H33C33 7.18629 30.3137 4.5 27 4.5V8.5ZM21 4.5C17.6863 4.5 15 7.18629 15 10.5H19C19 9.39543 19.8954 8.5 21 8.5V4.5Z"
        fill="#669CCC"
      />
      <path
        d="M20 40.5C20 39.3954 19.1046 38.5 18 38.5C16.8954 38.5 16 39.3954 16 40.5H20ZM16 42.5C16 43.6046 16.8954 44.5 18 44.5C19.1046 44.5 20 43.6046 20 42.5H16ZM16 40.5V42.5H20V40.5H16Z"
        fill="#669CCC"
      />
      <path
        d="M19 20.5C19 19.3954 18.1046 18.5 17 18.5C15.8954 18.5 15 19.3954 15 20.5H19ZM15 32.5C15 33.6046 15.8954 34.5 17 34.5C18.1046 34.5 19 33.6046 19 32.5H15ZM15 20.5V32.5H19V20.5H15Z"
        fill="#669CCC"
      />
      <path
        d="M26 20.5C26 19.3954 25.1046 18.5 24 18.5C22.8954 18.5 22 19.3954 22 20.5H26ZM22 32.5C22 33.6046 22.8954 34.5 24 34.5C25.1046 34.5 26 33.6046 26 32.5H22ZM22 20.5V32.5H26V20.5H22Z"
        fill="#669CCC"
      />
      <path
        d="M33 20.5C33 19.3954 32.1046 18.5 31 18.5C29.8954 18.5 29 19.3954 29 20.5H33ZM29 32.5C29 33.6046 29.8954 34.5 31 34.5C32.1046 34.5 33 33.6046 33 32.5H29ZM29 20.5V32.5H33V20.5H29Z"
        fill="#669CCC"
      />
      <path
        d="M32 40.5C32 39.3954 31.1046 38.5 30 38.5C28.8954 38.5 28 39.3954 28 40.5H32ZM28 42.5C28 43.6046 28.8954 44.5 30 44.5C31.1046 44.5 32 43.6046 32 42.5H28ZM28 40.5V42.5H32V40.5H28Z"
        fill="#669CCC"
      />
    </svg>,
  ];

  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div className={styles.backgroundMask}></div>
      <div className={styles.scenesHeder}>
        <div className={styles.scenesIconBox}>
          {scenesIcons.map((item) => item)}
        </div>
        <h2>
          <div className={styles.scenesTextBox} ref={scenesTextBoxRef}>
            <div
              className={styles.scenesTextItem}
              style={{ '--scenes-text-color': '#CC6666' }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text16']),
              }}
            ></div>
            <div
              className={styles.scenesTextItem}
              style={{ '--scenes-text-color': '#CC9F66' }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text17']),
              }}
            ></div>
            <div
              className={styles.scenesTextItem}
              style={{ '--scenes-text-color': '#669CCC' }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text18']),
              }}
            ></div>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text20']),
            }}
          ></div>
        </h2>
      </div>

      <div className={styles.imgBox}>
        {scenesIcons.map((item, index, array) => {
          return (
            <div
              key={index}
              style={{
                position: 'relative',
                zIndex: array.length - index,
              }}
            >
              <img
                src={`https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-${scenesImages[index]}.png`}
                alt=""
              />
            </div>
          );
        })}
      </div>

      <h6
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text21']),
        }}
      ></h6>
    </div>
  );
};

export default Scenes;
